import { Link } from "react-router-dom";
import Header from "../components/Header";

export default function NotFoundPage() {
  return (
    <>
      <Header />
      <div className="max-w-4xl mx-auto px-4 py-24 text-center space-y-4">
        <p className="text-6xl">🍽️</p>
        <h1
          className="text-3xl font-bold text-stone-800"
          style={{ fontFamily: "Georgia, serif" }}
        >
          Page not found
        </h1>
        <p className="text-stone-500">
          That page doesn&apos;t exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block mt-4 px-6 py-2 bg-herb text-white rounded-full text-sm hover:bg-herb-light transition-colors"
        >
          Back to recipes
        </Link>
      </div>
    </>
  );
}
